module.exports = __webpack_public_path__ + "img/ewm-kefu.bdd7f409.png";